:host {
  display: block;
}

.purchase {
  display: flex;
  flex-direction: column;
  gap: var(--sc-spacing-large);
}

.single-download {
  .single-download__preview {
    display: flex;
    align-items: center;
    justify-content: center;
    background: var(--sc-color-gray-200);
    border-radius: var(--sc-border-radius-small);
    height: 4rem;
    min-width: 4rem;
    width: 4rem;
  }
}
